import { render, staticRenderFns } from "./TaskObjects.vue?vue&type=template&id=91156cc8&"
import script from "./TaskObjects.vue?vue&type=script&lang=js&"
export * from "./TaskObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports